'use client';

import React from 'react';
import useBreakpoints, {
  orderedBreakpoints,
} from '@/components/hooks/useBreakpoints';
import type { VisibilityProps } from './types';

/*
 * Visibility Component
 *
 * Uses `Wrapper` to manage spacing, background, etc.
 * Supports `asChild` to avoid extra divs.
 */
function Visibility({
  id,
  visibleUntil,
  shouldShow,
  responsive = {},
  children,
  ...breakpointFlags
}: VisibilityProps) {
  // TODO: Rename breakpoint to something like screenBreakpoint and screenCurrentIndex for more clarity
  const breakpoint = useBreakpoints();
  const currentIndex = orderedBreakpoints.indexOf(breakpoint);

  const targetBreakpoint = orderedBreakpoints.find(bp => breakpointFlags[bp]);
  const targetIndex = targetBreakpoint
    ? orderedBreakpoints.indexOf(targetBreakpoint)
    : -1;

  let isVisible = true;

  if (targetIndex !== -1) {
    if (visibleUntil) {
      isVisible = currentIndex < targetIndex; // Visible before breakpoint
    } else {
      isVisible = currentIndex >= targetIndex; // Visible from breakpoint and up
    }
  }

  if (shouldShow === false) {
    return null;
  }

  if (shouldShow !== true && !isVisible) {
    return null;
  }

  return children;
}

export default React.memo(Visibility);
